import type { LoggingArgs } from "./LoggingArgs";

export function formatForUpload(
  loggingArgs: LoggingArgs[],
  userSessionId: string,
  uploadId: number,
  timestampBase: number
): string {
  const correlations: string[] = [];
  const entries = loggingArgs.map((element) =>
    getLogEntryInWireFormat(element, timestampBase, correlations)
  );
  const batch = getLogBatchInWireFormat(
    timestampBase,
    entries,
    userSessionId,
    uploadId,
    correlations
  );
  return JSON.stringify(batch);
}

/** Use this to shift up another int before adding the Level when concatenating for serialization. */
const shiftFactory = 1000;

/** Serialize a single bULS entry into over-the-wire format */
function getLogEntryInWireFormat(
  loggingArgs: LoggingArgs,
  timestampBase: number,
  correlations: string[]
): {} {
  const entry: any = {};
  entry["G"] = loggingArgs.tag;
  entry["T"] = loggingArgs.timestamp - timestampBase;
  entry["M"] = loggingArgs.message;
  entry["C"] = loggingArgs.category;
  if (loggingArgs.correlationId) {
    let index = correlations.findIndex(
      (val: string) => val === loggingArgs.correlationId
    );
    if (index < 0) {
      index = correlations.push(loggingArgs.correlationId) - 1;
    }
    entry["I"] = index;
  }

  // level and logType are combined into a single property called metadata
  const metadata = loggingArgs.type * shiftFactory + loggingArgs.level;
  entry["D"] = metadata;

  return entry;
}

function getLogBatchInWireFormat(
  timestampBase: number,
  logs: {}[],
  userSessionId: string,
  uploadId: number,
  correlations: string[]
) {
  const batch: any = {};
  batch["T"] = timestampBase;
  batch["L"] = logs;
  batch["S"] = userSessionId;
  batch["I"] = uploadId;
  if (correlations && correlations.length > 0) {
    batch["W"] = correlations;
  }

  // schema version
  batch["V"] = 1;

  return batch;
}
